export { default } from './ColumnChartWidgetStackedBars';
